import { Empty } from 'cpool-components/state/Empty';
import { useTranslation } from 'react-i18next';
import { LuLandmark } from 'react-icons/lu';

import { BankReportItem } from './BankReportItem';
import { CountBadge } from '../CountBadge';
import { IconBadge } from '../IconBadge';
import Spinner from '~/components/icons/Spinner';
import { useUnreadConsorsNotes } from '~/features/dashboard/hooks/useUnreadConsorsNotes';

export const BankReports: React.FC = () => {
    const { t } = useTranslation();
    const { data, isError, isLoading } = useUnreadConsorsNotes();

    if (!isError && (isLoading || !data)) {
        return (
            <div className="w-full inset-0 flex items-center justify-center z-50">
                <Spinner />
            </div>
        );
    }

    if (isError) {
        return (
            <div className="py-2.5 px-5">
                <span>{t('DASHBOARD.ERROR')}</span> <br />
                <span>{t('DASHBOARD.RELOAD')}</span>
            </div>
        );
    }

    const totalCount = data.length;

    if (totalCount === 0) {
        return (
            <div className="flex items-center justify-center h-full">
                <Empty
                    noBorder
                    icon={<LuLandmark />}
                    iconClassName="text-blue-text"
                    iconContainerClassName="bg-blue-cloud rounded-lg"
                    title={t('DASHBOARD.BANKREPORTS.TITLE', { count: totalCount })}
                    description={t('DASHBOARD.BANKREPORTS.NO_BANKREPORTS')}
                />
            </div>
        );
    }

    return (
        <section className="py-1">
            <div className="px-5 pb-3">
                <div className="flex items-center justify-between min-h-[28px]">
                    <h6 className="text-midnight flex items-center gap-4">
                        <IconBadge icon={<LuLandmark />} className="text-blue-text bg-blue-cloud" />
                        <div className="flex flex-col">
                            <span className="text-lg font-medium leading-none mb-0.5">
                                {t('DASHBOARD.BANKREPORTS.TITLE', { count: totalCount })}
                            </span>
                            <span className="text-sm">
                                {t('DASHBOARD.BANKREPORTS.SUBTITLE', { count: totalCount })}
                            </span>
                        </div>
                    </h6>
                    <CountBadge count={totalCount} className="text-blue-text bg-blue-cloud" />
                </div>
            </div>
            <div className="overflow-y-auto max-h-[180px] scrollbar-thin scrollbar-thumb-rounded-md scrollbar-thumb-dark scrollbar-track-grey-stroke scrollbar-track-rounded-md">
                <div className="px-1 flex flex-col">
                    {data.map((entry) => (
                        <BankReportItem key={entry.loanRequestId} data={entry} />
                    ))}
                </div>
            </div>
        </section>
    );
};
